module.exports = "https://web-assets.ifttt.com/packs/media/solutions_by_industry/subscription_services-d3302356.svg";